import { defineStore } from 'pinia'

import type { EatigoCurrencyCurrencyData } from '@/types/api'
import { getCurrency } from '@/service/currency'

export const useCurrencyStore = defineStore('currency', () => {
  const currencyList = ref<EatigoCurrencyCurrencyData[]>([])

  const currencyMapById = computed(() => convertArrayToKeyedObject(currencyList.value, 'id'))

  async function fetchCurrency() {
    const { data } = await getCurrency()

    currencyList.value = data.list || []

    return data
  }

  return {
    currencyList,
    currencyMapById,
    fetchCurrency,
  }
})
